import * as React from "react";

import PageWrapper from "~/common/layout/PageWrapper";
import PageContent from "~/common/layout/PageContent";

import SideMenu from "../containers/common/SideMenu";
import ProductsHeaderTabs from "../containers/products/ProductsHeaderTabs";
import PageContentWrapper from "~/common/layout/PageContentWrapper";
import ProductCategoriesHeader from "../containers/products/ProductCategoriesHeader";
import ProductCategoryList from "../containers/products/ProductCategoryList";

export default function (children: JSX.Element | null = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <ProductCategoriesHeader />
          <ProductsHeaderTabs />
          <PageContentWrapper>
            <ProductCategoryList />
          </PageContentWrapper>
          {children}
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
}
